import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Image = ({ src, width, height, borderRadius, style, onClick, className, previewFontSize }) => {
    return (
        <div style={{
            overflow: 'hidden',
            width: width,
            height: height,
            borderRadius: borderRadius,
            maxWidth: '100%',
            objectFit: 'cover',
            border: src ? 'none': '1px solid #ccc',
            ...style
        }}
            className={`${className}`}
        >
            {
                src ?
                <LazyLoadImage
                    src={src}
                    width={width}
                    height={height}
                    style={style}
                    onClick={onClick}
                    effect="blur"
                /> :
                <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                    <div><i className='fa fa-picture-o center' style={{fontSize: previewFontSize, color:'#bbb'}}></i></div>
                </div>
            }
        </div>
    );
}

export default Image;